import { render, staticRenderFns } from "./FarmNoti.vue?vue&type=template&id=34654fa3&"
import script from "./FarmNoti.vue?vue&type=script&lang=js&"
export * from "./FarmNoti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports